export default function Pagination({
    currentPage,
    totalPages,
    rowsPerPage,
    onPrev,
    onNext,
    onRowsChange,
    total
}) {
    return (
        <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-4 px-6 py-4">
            {/* ✅ Rows Per Page */}
            <div className="flex items-center gap-3">
                <span className="text-xs font-semibold text-slate-600 uppercase tracking-wide">
                    Records
                </span>

                <select
                    value={rowsPerPage}
                    onChange={(e) => onRowsChange(+e.target.value)}
                    className="px-4 py-2 text-sm font-semibold rounded-xl 
                     bg-gradient-to-br from-slate-50 to-slate-100
                     border border-slate-300 shadow-sm
                     focus:outline-none focus:ring-2 focus:ring-blue-300"
                >
                    {[10, 20, 25, 50, 75, 100].map((n) => (
                        <option key={n} value={n}>{n}</option>
                    ))}
                </select>
            </div>

            {/* ✅ Prev / Page / Next */}
            <div className="flex items-center gap-4">

                <button
                    disabled={currentPage === 1}
                    onClick={onPrev}
                    className={`px-4 py-2 text-sm font-bold rounded-xl transition-all duration-300
                    ${currentPage === 1
                            ? "bg-slate-200 text-slate-400 cursor-not-allowed"
                            : "bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-md hover:scale-105 hover:shadow-lg"
                        }`}
                >
                    Prev
                </button>

                <span className="px-4 py-1.5 rounded-xl text-sm font-bold 
                  bg-slate-100 text-slate-700 shadow-inner">
                    Page {currentPage} / {totalPages}
                </span>

                <button
                    disabled={currentPage === totalPages}
                    onClick={onNext}
                    className={`px-4 py-2 text-sm font-bold rounded-xl transition-all duration-300
                           ${currentPage === totalPages
                            ? "bg-slate-200 text-slate-400 cursor-not-allowed"
                            : "bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-md hover:scale-105 hover:shadow-lg"
                        }`}
                >
                    Next
                </button>
            </div>

            {/* ✅ Total Count */}
            <div className="flex items-center gap-2 px-4 py-2 rounded-xl 
               bg-gradient-to-r from-emerald-50 to-emerald-100 
                text-emerald-700 font-bold shadow-inner text-sm">
                Total : {total}
            </div>

        </div>

    );
}
